export const SET_PRODUCTS = "SET_PRODUCTS";
export const CLEAR_PRODUCTS = "CLEAR_PRODUCTS";
export const SET_PRODUCT_FAILED = "FETCH_PRODUCT_FAILED";

export const GET_PRODUCT = "GET_PRODUCT";
export const CLEAR_PURCHASE_PRODUCT = "CLEAR_PURCHASE_PRODUCT";
export const INCREMENT_PRODUCT_QUANTITY = "INCREMENT_PRODUCT_QUANTITY";
export const DECREMENT_PRODUCT_QUANTITY = "DECREMENT_PRODUCT_QUANTITY";

export const CLEAR_CART = "CLEAR_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const CART_INTERACTION_FAILED = "CART_INTERACTION_FAILED";
export const POPULATE_CART = "POPULATE_CART";
export const POPULATE_CART_FAILED = "POPULATE_CART_FAILED";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const ORDER_CART_PRODUCTS = "ORDER_CART_PRODUCTS";

export const USER_AUTH = "USER_AUTH";
export const USER_LOGOUT = "USER_LOGOUT";
export const SET_AUTH_REDIRECT = "SET_AUTH_REDIRECT";
export const AUTH_ERROR = "AUTH_ERROR";
